module.exports = __webpack_public_path__ + "static/img/2.97f0850.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/2.png
// module id = 85Ti
// module chunks = 0